export const includeOnlyIfDefined = <T extends object>(
	userData: Partial<T>,
	defaultData: T
): Partial<T> => {
	const result: Partial<T> = {};

	for ( const key of Object.keys( defaultData ) as Array<keyof T> ) {
		if ( userData[ key ] ) {
			const userValue = userData[ key ];
			const defaultValue = defaultData[ key ];

			if ( Array.isArray( userValue ) && Array.isArray( defaultValue ) ) {
				const nestedArrayDiffs = userValue.reduce<object>(
					( acc, item, index ) => {
						const defaultItem = defaultValue[ index ];

						if (
							item &&
							defaultItem &&
							typeof item === 'object' &&
							typeof defaultItem === 'object' &&
							!Array.isArray( item ) &&
							!Array.isArray( defaultItem )
						) {
							const nestedDiff = includeOnlyIfDefined(
								item as Partial<typeof defaultItem>,
								defaultItem
							);

							return Object.keys( nestedDiff ).length > 0
								? { ...acc, [ index ]: nestedDiff }
								: acc;
						}

						return item !== defaultItem
							? { ...acc, [ index ]: defaultItem }
							: acc;
					},
					{}
				);

				if (
					userValue.length !== defaultValue.length ||
					Object.keys( nestedArrayDiffs ).length > 0
				) {
					result[ key ] = defaultValue;
				}
			} else if (
				userValue &&
				defaultValue &&
				typeof userValue === 'object' &&
				typeof defaultValue === 'object'
			) {
				const nestedDiff = includeOnlyIfDefined(
					userValue as Partial<typeof defaultValue>,
					defaultValue
				);

				if ( Object.keys( nestedDiff ).length > 0 ) {
					result[ key ] = defaultValue;
				}
			} else if ( userValue !== defaultValue ) {
				result[ key ] = defaultValue;
			}
		}
	}

	return result;
};
